import React, { useRef } from 'react';
import { t } from 'Src/i18n';
import { Layer } from 'Components/frameworks/layer/Layer';
import { ICONS } from 'Components/utils/icon/icons';
import { LayerHeaderProposal } from 'Components/widgets/layer-header-proposal/LayerHeaderProposal';
import { ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE } from 'Components/utils/identifiers/constants';
import { AdditionalTransportFilters } from './AdditionalTransportFilters';
type AdditionalTransportFiltersLayerProps = {
  hasNoAlternativeTransport: boolean;
  hasOnlyTrain: boolean;
  proposal: Proposal;
  onClose: () => void;
  state: TransportFiltersState;
  updateFilters: (key: TransportFiltersKeys, value: string | TransportDateRange) => void;
  resetFilters: () => void;
};
export const AdditionalTransportFiltersLayer = ({
  hasNoAlternativeTransport,
  hasOnlyTrain,
  proposal,
  onClose,
  state,
  updateFilters,
  resetFilters,
}: AdditionalTransportFiltersLayerProps) => {
  const layerRef = useRef<null | HTMLElement>(null);
  const layerTitle = t('faceting.filters.filtersButton');
  return (
    <Layer
      ariaLabel={layerTitle}
      ariaLabelledby="testId"
      buttonLeft={{
        iconName: ICONS.ARROW_TAIL_LEFT,
        label: t('common.backNavigation'),
        onClick: onClose,
      }}
      header={
        <LayerHeaderProposal
          id={ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE}
          layerTitle={layerTitle}
          proposal={proposal}
          totalPrice={t('booking.transport.additionalTransports.totalPrice')}
        />
      }
      closeLabel={t('common.close')}
      onClose={onClose}
      ref={layerRef}
      dataTestId="AdditionalTransportLayer"
    >
      <AdditionalTransportFilters
        hasNoAlternativeTransport={hasNoAlternativeTransport}
        hasOnlyTrain={hasOnlyTrain}
        state={state}
        updateFilters={updateFilters}
        resetFilters={resetFilters}
        proposal={proposal}
      />
    </Layer>
  );
};
